import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { SelectContext } from './Select';

/**
 * Select.Option component that represents an option in the parent Select component.
 *
 * @component Select.Option
 * @param {Object} props - The properties for the Select.Option component.
 * @param {React.ReactNode} props.children - The text to be displayed as an option.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the Select.Option.
 * @param {Object} [restProps] - Additional properties to be passed to the Select.Option.
 * @returns {ReactElement} The rendered Select.Option component.
 */
export default function SelectOption({ children, className, ...restProps }) {
  useContext(SelectContext, 'Select.Option must be a child of Select.');

  return (
    <option className={mergeClasses('', className)} {...restProps}>
      {children}
    </option>
  );
}

SelectOption.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

SelectOption.defaultProps = {
  className: ''
};
